import React, { PropsWithChildren, useEffect } from 'react';
import { useAtom } from 'jotai';

import { useCurrentUser } from '@/hooks/useCurrentUser';
import {
  ALL_FACILITIES,
  selectedFacilityIdAtom
} from '@/hooks/useFacilitiesQuery';

export const CrmRequireSelectedFacility: React.FC<PropsWithChildren> = ({
  children
}) => {
  const { data: currentUser } = useCurrentUser();
  const [selectedFacilityId, setSelectedFacilityId] = useAtom(
    selectedFacilityIdAtom
  );

  useEffect(() => {
    // NOTE: ALL_FACILITIES was a special value when we supported views where a specific facility was not required.
    // We always need a facility to be selected by the current user now and in case it is not, we will automatically
    // select it.
    if (selectedFacilityId === ALL_FACILITIES) {
      setSelectedFacilityId(currentUser?.facility_id!);
    }
  }, [selectedFacilityId, currentUser?.facility_id, setSelectedFacilityId]);

  if (selectedFacilityId === ALL_FACILITIES) {
    return null;
  }

  return <>{children}</>;
};
